var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeCompleted = function SvgIconBadgeCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_badge_completed_svg__a",
    width: "133.3%",
    height: "133.3%",
    x: "-16.7%",
    y: "-16.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#E4884F",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon_badge_completed_svg__a)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.976 5.5C5.976 3.567 7.542 2 9.47 2c2.048 0 3.614 1.567 3.614 3.5V6h2.892c1.205 0 2.048.896 2.048 2v2C20.193 10 22 11.792 22 14s-1.807 4-3.976 4v2c0 1.105-.843 2-2.048 2H4.048C2.964 22 2 21.105 2 20v-2.959c0-.574.482-1.04 1.084-1.04h1.687c.843 0 1.446-.673 1.446-1.5 0-.83-.603-1.5-1.446-1.5H3.084C2.482 13 2 12.533 2 11.958V8c0-1.104.964-2 2.048-2h1.928zM9.47 4c-.723 0-1.446.672-1.446 1.5V6.96C8.024 7.535 7.542 8 6.94 8H4.048v3h.723a3.5 3.5 0 0 1 3.494 3.5c0 1.933-1.566 3.5-3.494 3.5h-.723v2h11.928v-2.96c0-.575.482-1.04 1.084-1.04h.964c1.084 0 2.048-.896 2.048-2s-.964-2-2.048-2h-.964c-.602 0-1.084-.466-1.084-1.04V8H12.12c-.602 0-1.084-.465-1.084-1.039V5.5c0-.828-.723-1.5-1.566-1.5"
  })))));
};
export default SvgIconBadgeCompleted;